export default __webpack_public_path__ + "static/media/Group-931.f9620e92.svg";